import { useMutation } from "react-query";

import { invalidateQuery, useApiQuery } from "@/api";
import { DataConnector, DataConnectorStatus } from "@/api/data-connectors";
import { makeRequest } from "@/util";

export const useDataConnectors = () => {
  return useApiQuery(["get_data_connectors", {}]);
};

export const useDataConnectorDetails = (id: string) => {
  return useApiQuery(["get_data_connector_details", { id }], {});
};

export type CreateDataConnectorData = Pick<DataConnector, "type" | "name">;

export const useCreateDataConnectors = () =>
  useMutation(
    (payload: CreateDataConnectorData) =>
      makeRequest<DataConnector>("create_data_connector", payload),
    {
      onSuccess: () => {
        invalidateQuery(["get_data_connectors"]);
      },
    },
  );

export const useUpdateDataConnectors = () =>
  useMutation(
    ({ id, payload }: { id: string; payload: CreateDataConnectorData }) =>
      makeRequest<DataConnector>("update_data_connector", { id, ...payload }),
    {
      onSuccess: ({ data: { id } }) => {
        invalidateQuery(["get_data_connectors"]);
        invalidateQuery(["get_data_connector_details", { id }]);
      },
    },
  );

export const useSetDataConnectorStatus = () =>
  useMutation(
    ({ id, status }: { id: string; status: DataConnectorStatus }) =>
      makeRequest<DataConnector>("set_data_connector_status", { id, status }),
    {
      onSuccess: ({ data: { id } }) => {
        invalidateQuery(["get_data_connectors"]);
        invalidateQuery(["get_data_connector_details", { id }]);
      },
    },
  );
